/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Ask } from '../fn/little-tiff/ask';
import { Ask$Params } from '../fn/little-tiff/ask';
import { Feedback } from '../fn/little-tiff/feedback';
import { Feedback$Params } from '../fn/little-tiff/feedback';
import { LittleTiffAskResponse } from '../models/little-tiff-ask-response';
import { LittleTiffStatus } from '../models/little-tiff-status';
import { Status } from '../fn/little-tiff/status';
import { Status$Params } from '../fn/little-tiff/status';

@Injectable({ providedIn: 'root' })
export class LittleTiffApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLittleTiffStatusGet()` */
  static readonly ApiLittleTiffStatusGetPath = '/api/LittleTiff/Status';

  /**
   * Called when the assistant panel is first opened.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Status()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status$Response(params?: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<LittleTiffStatus>> {
    return Status(this.http, this.rootUrl, params, context);
  }

  /**
   * Called when the assistant panel is first opened.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Status$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status(params?: Status$Params, context?: HttpContext): Observable<LittleTiffStatus> {
    return this.Status$Response(params, context).pipe(
      map((r: StrictHttpResponse<LittleTiffStatus>): LittleTiffStatus => r.body)
    );
  }

  /** Path part for operation `apiLittleTiffAskPost()` */
  static readonly ApiLittleTiffAskPostPath = '/api/LittleTiff/Ask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Ask()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Ask$Response(params?: Ask$Params, context?: HttpContext): Observable<StrictHttpResponse<LittleTiffAskResponse>> {
    return Ask(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Ask$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Ask(params?: Ask$Params, context?: HttpContext): Observable<LittleTiffAskResponse> {
    return this.Ask$Response(params, context).pipe(
      map((r: StrictHttpResponse<LittleTiffAskResponse>): LittleTiffAskResponse => r.body)
    );
  }

  /** Path part for operation `apiLittleTiffFeedbackPost()` */
  static readonly ApiLittleTiffFeedbackPostPath = '/api/LittleTiff/Feedback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Feedback()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Feedback$Response(params?: Feedback$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Feedback(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Feedback$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Feedback(params?: Feedback$Params, context?: HttpContext): Observable<void> {
    return this.Feedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
